import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'inactive',
  has_access: false,
  plan_type: 'monthly',
  plan_name: 'Monthly Plan',
  current_period_end: null,
  days_until_expiry: null,
  expires_soon: false,
  payment_status: 'none', // Changed from 'unknown' to 'none' for better UX
  renewal_required: false,
  is_active: false,
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionStatus: (state, action) => {
      const { 
        status, 
        has_access, 
        plan_type, 
        plan_name, 
        current_period_end,
        days_until_expiry,
        expires_soon,
        payment_status,
        renewal_required,
        is_active,
        ...rest 
      } = action.payload;
      
      state.status = status || state.status;
      state.has_access = has_access ?? state.has_access;
      state.plan_type = plan_type || state.plan_type;
      state.plan_name = plan_name || state.plan_name;
      state.current_period_end = current_period_end ?? state.current_period_end;
      state.days_until_expiry = days_until_expiry ?? state.days_until_expiry;
      state.expires_soon = expires_soon ?? state.expires_soon;
      // Enhanced payment_status handling with fallback logic
      if (payment_status !== undefined) {
        state.payment_status = payment_status;
      } else if (has_access && is_active) {
        // If we have access and are active but no payment_status, assume current
        state.payment_status = 'current';
      }
      state.renewal_required = renewal_required ?? state.renewal_required;
      state.is_active = is_active ?? state.is_active;
      
      Object.assign(state, rest);
      state.error = null;
    },
    setSubscriptionLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSubscriptionError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearSubscription: (state) => {
      state.status = 'inactive';
      state.has_access = false;
      state.plan_type = 'monthly';
      state.plan_name = 'Monthly Plan';
      state.current_period_end = null;
      state.days_until_expiry = null;
      state.expires_soon = false;
      state.payment_status = 'none'; // Changed from 'unknown' to 'none'
      state.renewal_required = false;
      state.is_active = false;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setSubscriptionStatus,
  setSubscriptionLoading,
  setSubscriptionError,
  clearSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;